import { signal } from "@preact/signals-react"

// Schedules Table
export const isLoadingSchedules = signal(true)
export const schedulesTableData = signal([])
export const schedulesTableState = signal({
    sortOrder: { name: 'createdAt', direction: 'desc' },
    page: 0,
    rowsPerPage: 10,
    searchText: ''
})

// Create/Edit Schedule Drawers
export const isCreateScheduleDrawerOpen = signal(false)
export const isEditScheduleDrawerOpen = signal(false)
export const selectedScheduleForEdit = signal(null)

const emptyScheduleFormData = () => ({
    schedule_name: '',
    batch_type: 'raw2sku',
    id_customer: null,          // own column since migration 053, not part of config
    frequency: 'monthly',
    every_n_days: null,         // only read when frequency === 'custom'
    // 'HH:MM' office time (Europe/Madrid), empty = the house default the back applies.
    // The back anchors next_execution at this hour, so the date field below is a DAY.
    execution_time: '',
    is_active: true,
    next_execution: null,
    config: {
        sites: [],
        brands: [],
        // 'yesterday' | 'last_n_days' | 'last_7_days' | 'last_30_days'
        // | 'current_month' | 'previous_month' | 'custom'
        date_range_type: 'last_30_days',
        dateStart: null,  // Only used if date_range_type === 'custom'
        dateEnd: null,    // Only used if date_range_type === 'custom'
        dateField: 'end_date',
        // Left empty to inherit the house defaults the scheduler applies at run time.
        maxDaysSinceSeen: null,
        autoSecondPass: null,
        autoValidation: {
            minRateAutovalidate: null,
            minGapSecondCandidate: null,
            maxRateAutoexclude: null
        }
    }
})

// Schedule Form Data
export const scheduleFormData = signal(emptyScheduleFormData())

// Reset form data
export const resetScheduleFormData = () => {
    scheduleFormData.value = emptyScheduleFormData()
}
